import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './tooltip-text-secondary.module.css';

type Props = {
    align?: 'left' | 'center';
    children: React.ReactNode;
    className?: string;
};

export const TooltipTextSecondary = ({align = 'center', children, className}: Props) => {
    const typographyClass = useTypography({
        size: TypographySize.BodyXS,
        noDefaultColor: true,
    });

    return <div className={classNames(styles.root, styles[align], typographyClass, className)}>{children}</div>;
};
